module.exports = __webpack_public_path__ + "static/media/img-1.fe613852.png";